import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Features } from "@/components/Features";
import { MasterPlan } from "@/components/MasterPlan";
import { ResidenceHotel } from "@/components/ResidenceHotel";
import { Location } from "@/components/Location";
import { Plans } from "@/components/Plans";
import { Gallery } from "@/components/Gallery";
import { Investment } from "@/components/Investment";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
  return (
    <LanguageProvider>
      <div className="bg-[#0A0A0A] min-h-screen text-[#FFFFF0] antialiased overflow-x-hidden">
        <Header />
        <main>
          <Hero />
          <About />
          <Features />
          <MasterPlan />
          <ResidenceHotel />
          <Location />
          <Plans />
          <Gallery />
          <Investment />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid #2E2E2E",
              color: "#FFFFF0",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
